import {
  SET_CONTRACT_DETAILS_TYPE,
  VIEW_CONTRACT_DETAILS_TOGGLE,
  RESET_CONTRACT_DETAILS,
  SET_REQUEST_CONTRACT_DETAILS,
  SET_DISABLE_NEXT,
  SET_CONTACT_FORM_DETAILS_ERROR,
  SET_CASE_CREATION_SUCCESS,
  ACTIVE_CANCELLATION_CASE_LIST,
  IS_ACTIVE_CANCELLATION_ERROR,
  IS_ACTIVE_CANCELLATION_SUCCESS,
  CANCELLATION_CASE_DETAILS_LOADER,
  SET_DUPLICATE_REQUEST,
  RESET_CANCELLATION_CASE_DETAILS,
} from "../../actions/contract/myContractDetailsActions";

const initState = {
  viewContractDetailsToggle: false,
  contractDetailsType: "",
  dateToBegin: "",
  contactName: "",
  contactEmailAddress: "",
  contactPhoneNumber: "",
  reason: "",
  reasonDescription: "",
  contractContact: "",
  disableNext: true,
  contactNameErr: false,
  contactEmailAddressErr: false,
  contactPhoneNumberErr: false,
  caseCreationSuccess: false,
  accountPhoneNumber: "",
  accountEmailId: "",
  cancellationCaseList: [],
  isActiveCancellationError: false,
  isActiveCancellationSuccess: false,
  isLoader: false,
  isDuplicateRequest: false,
};

const contractDetailsReducer = (state = initState, action) => {
  switch (action.type) {
    case VIEW_CONTRACT_DETAILS_TOGGLE:
      return {
        ...state,
        viewContractDetailsToggle: action.value,
      };
    case SET_CONTRACT_DETAILS_TYPE:
      return {
        ...state,
        contractDetailsType: action.value,
      };

    case SET_REQUEST_CONTRACT_DETAILS:
    case SET_CONTACT_FORM_DETAILS_ERROR:
      return {
        ...state,
        [action.field]: action.value,
      };

    case RESET_CONTRACT_DETAILS:
      return {
        ...state,
        viewContractDetailsToggle: false,
        contractDetailsType: "",
        dateToBegin: "",
        contactName: "",
        contactEmailAddress: "",
        contactPhoneNumber: "",
        reason: "",
        reasonDescription: "",
        contractContact: "",
        disableNext: true,
        contactNameErr: false,
        contactEmailAddressErr: false,
        contactPhoneNumberErr: false,
        cancellationCaseList: [],
        isActiveCancellationSuccess: false,
        isActiveCancellationError: false,
        isLoader: false,
        isDuplicateRequest: false,
      };

    case SET_DISABLE_NEXT:
      return {
        ...state,
        disableNext: action.value,
      };

    case SET_CASE_CREATION_SUCCESS:
      return {
        ...state,
        caseCreationSuccess: action.value,
      };

    case ACTIVE_CANCELLATION_CASE_LIST:
      return {
        ...state,
        cancellationCaseList: action.value,
      };

    case IS_ACTIVE_CANCELLATION_ERROR:
      return {
        ...state,
        isActiveCancellationError: action.value,
      };

    case IS_ACTIVE_CANCELLATION_SUCCESS:
      return {
        ...state,
        isActiveCancellationSuccess: action.value,
      };

    case CANCELLATION_CASE_DETAILS_LOADER:
      return {
        ...state,
        isLoader: action.value,
      };

    case SET_DUPLICATE_REQUEST:
      return {
        ...state,
        isDuplicateRequest: action.value,
      };

    case RESET_CANCELLATION_CASE_DETAILS:
      return {
        ...state,
        cancellationCaseList: [],
        isActiveCancellationSuccess: false,
        isActiveCancellationError: false,
        isLoader: false,
        isDuplicateRequest: false,
      };
    default:
      return state;
  }
};

export default contractDetailsReducer;
